import React, { useState, useEffect } from "react";
import withLanguageContext from "lib/hocs/withLanguageContext";
import styled from "styled-components";

/* DateSelect */
export const StyledValidationSummary = styled.div`
  margin: 10px 0;
`;

const ValidationSummary = (props) => {
  const { languageContext, errors } = props;

  const [errorText, setErrorText] = useState("");

  useEffect(() => {
    let err = "";
    errors.forEach((e) => {
      err = err ? err + "<div>" + e.msg + "</div>" : "<div>" + e.msg + "</div>";
    });

    setErrorText(err);
  }, [errors]);

  return (
    <StyledValidationSummary
      className="valsum-error"
      dangerouslySetInnerHTML={{ __html: errorText }}
    ></StyledValidationSummary>
  );
};

export default withLanguageContext(ValidationSummary, "error");
